import { render, staticRenderFns } from "./ProteinSequence.vue?vue&type=template&id=2d32b130&lang=pug&"
import script from "./ProteinSequence.vue?vue&type=script&lang=js&"
export * from "./ProteinSequence.vue?vue&type=script&lang=js&"
import style0 from "./ProteinSequence.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports